import transformStyle from 'rtl-css-js';

export default function rtl() {
  var defaultDirection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rtl';

  return function (style, type, renderer, props) {
    var direction = props && props.theme && props.theme.direction || defaultDirection;

    if (direction === 'rtl') {
      return transformStyle(style);
    }

    return style;
  };
}